<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <div
                class="ribbon"
                v-if="item.featured !== undefined && item.featured == true"
              >
                <span>NEW</span>
              </div>

              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img
                v-else-if="item.imagem !== ''"
                :src="item.imagem !== '' ? item.imagem : ''"
                alt=""
              />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <Footer />
    <FeedbackModal
      :show="showFeedbackModal"
      @close="showFeedbackModal = false"
    />
  </div>
</template>

<script>
import Menu from '../components/Menu'
import Footer from '../components/Footer'
import FeedbackModal from '../components/ModalNps.vue'
import { mapState } from 'vuex'
import EnvioApp from '@/components/icons/EnvioApp.vue'
import ProfissionaisPecCnes from '@/components/icons/ProfissionaisPecCnes.vue'
import VisitasDomiciliares from '@/components/icons/VisitasDomiciliares.vue'
import InformatizaAps from '@/components/icons/InformatizaAps.vue'
import SaudeCrianca from '@/components/icons/SaudeCrianca.vue'
import GestaoCadastros from '@/components/icons/GestaoCadastros.vue'
import IndicadoresEsb from '@/components/icons/IndicadoresEsb.vue'
import IndicadoresAps from '@/components/icons/IndicadoresAps.vue'
import AedesAegypti from '@/components/icons/AedesAegypti.vue'
import PosCovid19 from '@/components/icons/PosCovid19.vue'
import VinculoAcompanhamento from '@/components/icons/VinculoAcompanhamento/VinculoAcompanhamento.vue'

export default {
  name: 'Dashboard',
  metaInfo: {
    title: 'eSUS Feedback - Dashboard',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    EnvioApp,
    ProfissionaisPecCnes,
    VisitasDomiciliares,
    InformatizaAps,
    SaudeCrianca,
    GestaoCadastros,
    IndicadoresEsb,
    IndicadoresAps,
    AedesAegypti,
    PosCovid19,
    VinculoAcompanhamento,
    FeedbackModal,
  },
  data() {
    return {
      showCardVersion: true,
      deferredPrompt: null,
      cadastros: [],
      nomeProfissional: '',
      showModalBuscaAtiva: false,
      notificacao: {},
      showFeedbackModal: false,
    }
  },
  computed: {
    ...mapState(['id_funcao']),
    cards() {
      if (
        this.$store.state &&
        this.$store.state.permissoes &&
        this.$store.state.permissoes.dashboard
      ) {
        const dashboardClone = [...this.$store.state.permissoes.dashboard]
        return dashboardClone.sort((a, b) => a.ordem - b.ordem)
      }
      return []
    },
  },
  methods: {
    async verificarDataNpsEfb() {
      // Se for demonstração desabilita o modal automaticamente
      if (this.$store.state.demonstracao) {
        this.showFeedbackModal = false
        return
      }

      // Verificar se o modal já foi fechado
      const isAptoFromStorage = sessionStorage.getItem('aptoAvaliacaoNps')

      if (isAptoFromStorage === 'false') {
        this.showFeedbackModal = false
        return
      }

      // Recuperar a data NPS EFB do store
      const npsEfbDate = this.$store.state.npsEfb
        ? new Date(this.$store.state.npsEfb)
        : null
      const currentDate = new Date()

      let diffMonths = 0
      let moreThan4Months = false

      if (npsEfbDate) {
        // Cálculo da diferença em meses
        diffMonths =
          (currentDate.getFullYear() - npsEfbDate.getFullYear()) * 12 +
          (currentDate.getMonth() - npsEfbDate.getMonth())

        moreThan4Months =
          diffMonths > 4 ||
          (diffMonths === 4 && currentDate.getDate() > npsEfbDate.getDate())
      }

      // Verifica se está apto (mais de 4 meses ou data NPS EFB é nula ou vazia)
      const isApto = moreThan4Months || !npsEfbDate
      this.showFeedbackModal = isApto

      if (isApto) {
        sessionStorage.setItem('aptoAvaliacaoNps', 'true')
      }
    },
  },
  mounted() {
    this.verificarDataNpsEfb()
  },
}
</script>

<style>
/* The Modal (background) */
.modal-pwa {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.modal-pwa-content {
  background-color: #fefefe;
  margin: 15% auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 80%; /* Could be more or less, depending on screen size */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.modal-pwa-content h2 {
  font-size: 18px;
  margin: 15px 0;
  text-align: center;
}

.modal-pwa-content p {
  font-size: 14px;
  text-align: center;
}

.modal-pwa-content img {
  width: 100px;
}

.modal-pwa-content hr {
  margin: 10px 0;
  border-top: 1px solid #ccc;
}

.modal-pwa-content button {
  border: 1px solid #ccc;
  background-color: #fff;
  border-radius: 50px;
  margin-bottom: 10px;
  padding: 5px 20px;
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

#bv-modal-notificacao header {
  background-image: none;
}

#bv-modal-notificacao .modal-dialog {
  max-width: 800px;
}

.notificacao-header {
  text-align: center;
  background-color: #f3f3f3;
  padding: 10px 0;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.notificacao-header h3 {
  color: red;
  text-transform: uppercase;
  font-size: 32px;
  font-weight: 700;
}

.notificacao-header h3 i {
  color: red;
}

.notificacao-header p {
  margin-bottom: 0;
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 700;
}

@media (max-width: 768px) {
  .main {
    margin: 20px auto;
  }

  .modal-pwa {
    display: block;
  }

  #bv-modal-notificacao .modal-dialog {
    max-width: 100%;
  }
}
</style>
